import React, { useState } from 'react'
import './Header.css'

import logo from '../assets/images/logo-anabarber-negro.png'
import whatsappIcon from '../assets/icons/whatsapp-brands-solid-full.svg'
import mailIcon from '../assets/icons/envelope-regular-full.svg'
import menuIcon from '../assets/icons/bars-solid-full.svg' // ícono del menú hamburguesa
import closeIcon from '../assets/icons/xmark-solid-full.svg' // ícono de cerrar menú

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const handleLinkClick = () => {
    setMenuOpen(false) // cierra el menú al hacer clic en un enlace
  }

  return (
    <header className="header-container">
      {/* LOGO + NOMBRE */}
      <div className="header-logo">
        <img src={logo} alt="Logo" className="logo-img" />
        <span className="site-name">Dra. Ana Barber</span>
      </div>

      {/* BOTÓN HAMBURGUESA */}
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-label="Abrir menú de navegación"
      >
        <img src={menuOpen ? closeIcon : menuIcon} alt="Menú" />
      </button>

      {/* MENÚ DE NAVEGACIÓN */}
      <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="/" onClick={handleLinkClick}>Inicio</a></li>
          <li><a href="#especialidades" onClick={handleLinkClick}>Especialidades</a></li>
          <li><a href="#sobre-mi" onClick={handleLinkClick}>Sobre mí</a></li>
          <li><a href="#afiliaciones" onClick={handleLinkClick}>Afiliaciones y Membresías</a></li>
          <li><a href="#testimonios" onClick={handleLinkClick}>Testimonios</a></li>
          <li><a href="#footer" onClick={handleLinkClick}>Contacto</a></li>
        </ul>
      </nav>

      {/* ICONOS DE CONTACTO */}
      <div className="header-icons">
        <a href="https://wa.me/56944428019" target="_blank" rel="noopener noreferrer">
          <img src={whatsappIcon} alt="WhatsApp" />
        </a>
        <a href="mailto:anilubar@hotmail.com">
          <img src={mailIcon} alt="Correo" />
        </a>
      </div>
    </header>
  )
}

export default Header
